import { Box, useTheme } from '@mui/material';
import { AnimatePresence, LayoutGroup, motion } from 'framer-motion';
import { useMemo } from 'react';
import { useAppSelector } from '../../app/hooks';
import {
  ChartDropdownDimensionEnum,
  selectCurrChartDimension,
} from '../../services/data/impl/cube/cubeSlice';
import { isBlueberryFeature } from '../../services/data/impl/cube/cubeUtils';
import { selectCurrFeature } from '../select/selectSlice';
import { CubeChart } from './CubeChart';
import { BlueberrySizeChart } from './blueberry/sizing/BlueberrySizeChart';
import ColorToolbox from './colorToolbox/ColorToolbox';

const ChartAreaContent: React.FC = () => {
  const theme = useTheme();
  const currChartDimension = useAppSelector(selectCurrChartDimension);
  const currFeature = useAppSelector(selectCurrFeature);

  const gridArea = useMemo(() => {
    let newArea = `
    'chartArea'
  `;

    if (currChartDimension === ChartDropdownDimensionEnum.colorDistribution) {
      newArea = `
      'chartArea'
      'colorToolboxArea'
    `;
    }

    return newArea;
  }, [currChartDimension]);

  const gridTemplateRows = useMemo(() => {
    let newGridTemplateRows = '1fr';
    if (currChartDimension === ChartDropdownDimensionEnum.colorDistribution) {
      newGridTemplateRows = '1fr min-content';
    }

    return newGridTemplateRows;
  }, [currChartDimension]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minWidth: '500px',
        borderBottomLeftRadius: theme.borderRadius.primary,
        borderBottomRightRadius: theme.borderRadius.primary,
        overflow: 'hidden',
        display: 'grid',
        gridTemplateRows: gridTemplateRows,
        gridTemplateColumns: '1fr',
        gridTemplateAreas: gridArea,
      }}
    >
      <LayoutGroup>
        {currChartDimension === ChartDropdownDimensionEnum.fruitSize ? (
          <BlueberrySizeChart />
        ) : (
          <motion.div
            layout
            style={{
              gridArea: 'chartArea',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: theme.recentScansPage.card.textPadding,
              paddingRight: theme.recentScansPage.card.textPadding,
              paddingLeft: '5px', // axis labels need less padding
              paddingBottom: '5px',
            }}
          >
            <CubeChart />
          </motion.div>
        )}

        {currChartDimension === ChartDropdownDimensionEnum.colorDistribution &&
          !isBlueberryFeature(currFeature) && (
            <AnimatePresence>
              <motion.div
                layout
                style={{
                  gridArea: 'colorToolboxArea',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <ColorToolbox />
              </motion.div>
            </AnimatePresence>
          )}
      </LayoutGroup>
    </Box>
  );
};

export default ChartAreaContent;

{
  /* <AnimatePresence>
        <motion.div
          layout
          style={{
            gridArea: gridArea,
            width: '100%',
            height: '100%',
            overflow: overflowHidden ? 'hidden' : 'unset', // used to apply border radius to children
            borderRadius: theme.borderRadius.primary,
            boxShadow: 'none',
            // boxShadow: '0px 4px 20px #cccccc',
            // boxShadow: '0px 4px 20px #DDDDDD',
            backgroundColor: theme.colors.darkTheme.grey.light,
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridTemplateRows: displayHeader ? 'min-content 1fr' : '1fr',
            position: 'relative',
            minHeight: minHeight,
            ...style,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {displayHeader && <RanchAreaHeader gridArea={gridArea} />}
          {displayFullscreenButtonWithoutHeader && (
            <RanchAreaFullscreenToggle gridArea={gridArea} />
          )}
          {children}
        </motion.div>
      </AnimatePresence> */
}
